"use strict";

define('collection/common.rule.collection',['require','exports','module','./base','../model/common.rule.model'],function (require, exports, module) {
  var BaseCollection = require('./base'),
    CommonRuleModel = require('../model/common.rule.model');
  var CommonRuleCollection = BaseCollection.extend({
    model: CommonRuleModel,
    url: '/rs/api/type/commonRulePolicy'
  });
  module.exports = CommonRuleCollection;
});

